import React from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown, getTranslation, Icon, PeopleIcon,
} from '@resy/ui-kitchen';

import getOptions from './getOptions';

import './PartySizeSelector.scss';

const PartySizeSelector = (props) => {
  const {
    onChange,
    onClick,
    quantitySelected,
    showChevron,
    shopSmallMaxGuest,
  } = props;

  const oneGuest = getTranslation({
    translationKey: 'one_guest',
    fallback: '1 Guest',
  });
  const getNumberGuests = (number) => getTranslation({
    translationKey: 'number_guests',
    translationValues: { number },
    fallback: `${number} Guests`,
  });
  const options = getOptions(oneGuest, getNumberGuests, shopSmallMaxGuest);

  const handleFormatLabel = (option) => {
    if (!option) {
      // eslint-disable-next-line no-param-reassign
      option = { value: quantitySelected };
    }

    return (
      <div className="PartySizeSelector__wrapper">
        <Icon
          component={PeopleIcon}
          name="people"
          height="16px"
          width="16px"
        />
        <span>{option.value}</span>
      </div>
    );
  };

  return (
    <div className="PartySizeSelector">
      <Dropdown
        name="party_size"
        theme="nav"
        onChange={onChange}
        onClick={onClick}
        options={options}
        selected={quantitySelected}
        formatLabel={handleFormatLabel}
        showChevron={showChevron}
      />
    </div>
  );
};

PartySizeSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  quantitySelected: PropTypes.string,
  showChevron: PropTypes.bool,
  shopSmallMaxGuest: PropTypes.number,
};

PartySizeSelector.defaultProps = {
  quantitySelected: '2',
  showChevron: true,
  shopSmallMaxGuest: undefined,
};

PartySizeSelector.displayName = 'PartySizeSelector';
export default PartySizeSelector;
